module.exports = __webpack_public_path__ + "b4804aac95a467a4cd3df287e982f04b.png";


//////////////////
// WEBPACK FOOTER
// ../img/pricing-star.png
// module id = 2792
// module chunks = 11